var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 4.003a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0M4 4.003a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-1.095 7.874h8.192a3.055 3.055 0 0 0-3.024-2.625H5.931a3.055 3.055 0 0 0-3.023 2.625zm-1.155.43a4.18 4.18 0 0 1 4.179-4.18H8.07a4.18 4.18 0 0 1 4.179 4.18.696.696 0 0 1-.696.695H2.446a.696.696 0 0 1-.696-.696"
  })));
};
export default SvgUser;